import { useSectionContent } from "@/hooks/useContent";

export default function Marquee() {
  const { text } = useSectionContent("marquee");
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden bg-[#121215] py-4 border-y border-[#C5A059]/20 opacity-90"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((i) => (
          <span
            key={i}
            className="font-mono text-sm tracking-[0.3em] text-[#C5A059] pr-2"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
